import { User } from '@/modules/user';
import * as constants from './constants';

export function isDevDomain() {
	if (
		window.location.hostname == "localhost"
	)
		return true
	return false
}

export function isDevEnvironment() {
	return process.env.NODE_ENV && process.env.NODE_ENV === "development" && window.location.hostname == "localhost";
}

export function shoudlSwitchDay() {
	const now = new Date();
	const switchDate =  new Date();
	switchDate.setHours(constants.switchDay, 0, 0, 0);

	return now.getTime() > switchDate.getTime();
}

export function getUserInitialsFromUser(user?: User): string {
	if (!user) {
		return '';
	}
	return `${user.name.slice(0, 1).toUpperCase()}${user.surname.slice(0, 1).toUpperCase()}`
}

export function getDayIndexFromDate(date: Date): number {
	const today = addDayByOffset(0);
	const tomorrow = addDayByOffset(1);
	const afterTomorrow = addDayByOffset(2);

	if (compareDates(date, today)) {
		return 0;
	} else if (compareDates(date, tomorrow)) {
		return 1;
	} else if (compareDates(date, afterTomorrow)) {
		return 2;
	}

	return 0;
}

function addDayByOffset(offset: number): { start: Date, end: Date } {
  const startDate = new Date();
  startDate.setDate(startDate.getDate() + offset);
  startDate.setHours(0, 0, 0, 0);

  const endDate = new Date(startDate);
  endDate.setHours(23, 59, 59, 999);
	
	return { start: startDate, end: endDate };
}

function compareDates(target: Date, range: { start: Date, end: Date }): boolean {
	return target.getTime() >= range.start.getTime() && target.getTime() <= range.end.getTime();
}